<template>
  <div
    :style="{ height: height+'px', width: width+'px' }"
    :class="{ cssClass: true, 'p-file-preview--rounded': rounded !== false, 'p-file-preview--bordered': bordered !== false }"
    class="p-file-preview"
  >
    <img
      v-if="imageSrc"
      :src="imageSrc"
      class="p-file-preview__image"
    />

    <p-file-icon
      v-else
      :extension="extension"
      :mime-type="mimeType"
      :size="iconSize"
      class="p-file-preview__icon"
    ></p-file-icon>
  </div>
</template>


<script>
import PFileIcon from './PFileIcon'

export default {
  components: {
    PFileIcon
  },


  props: {
    file: {
      type: undefined, // either js File object or partitur File object
      required: true
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    iconSize: {
      type: Number,
      default: 40
    },
    cssClass: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    }
  },


  computed: {
    mimeType () {
      return this.file.type || this.file.contentType
    },

    extension () {
      let ext = this.file.extension

      if (!ext && this.file.name) {
        const dotIndex = this.file.name.indexOf('.')
        if (dotIndex !== -1) {
          ext = this.file.name.substring(dotIndex + 1)
        }
      }

      return ext
    },

    imageSrc () {
      if (this.file instanceof File && this.file.type?.startsWith('image')) {
        return URL.createObjectURL(this.file)
      }

      if (this.file.previewUrl) {
        return this.file.previewUrl
      }

      return null
    }
  }
}
</script>
